import React from 'react';
import styled from 'styled-components';

import { CommonTheme, useCurrentTheme } from 'app/shared/theme';
import {
  withBackgroundCSS,
  withDimensionsCSS,
} from 'app/shared/components/styleUtils';
import {
  Grid,
  GridItem,
  GridItemProps,
  GridProps,
} from 'app/shared/components/atoms';

// We do not want this style to be the default for all Grids,
// but it should definitely be the default for template Grids.
const StyledGrid = styled(Grid)<PageGridProps>`
  grid-auto-flow: dense;
  width: 100%;
  ${withBackgroundCSS};
  ${withDimensionsCSS};
`;

interface PageGridProps extends GridProps {
  backgroundColor?: string;
  withMaxPageWidth?: boolean;
}

export const BasePageGrid: React.FC<React.PropsWithChildren<PageGridProps>> = ({
  children,
  withMaxPageWidth = true,
  ...props
}) => {
  const { dimensions } = useCurrentTheme() as CommonTheme;
  const maxWidth = withMaxPageWidth
    ? `${dimensions.maxPageWidth}px`
    : undefined;
  const mx = withMaxPageWidth ? 'auto' : undefined;
  return (
    <StyledGrid
      mobileNumberOfColumns={4}
      mobileGap={5}
      tabletNumberOfColumns={8}
      tabletGap={5}
      smallDesktopNumberOfColumns={12}
      smallDesktopGap={8}
      largeDesktopNumberOfColumns={12}
      largeDesktopGap={10}
      maxWidth={maxWidth}
      mx={mx}
      px={dimensions.horizontalPadding.pageGrid}
      {...props}
    >
      {children}
    </StyledGrid>
  );
};

export const FullWidthColumn: React.FC<
  React.PropsWithChildren<GridItemProps>
> = ({ children, ...props }) => {
  const { dimensions } = useCurrentTheme();
  return (
    <GridItem
      mobile={4}
      tablet={8}
      smallDesktop={12}
      tabletStart={1}
      {...props}
      px={dimensions.horizontalPadding.pageGridItem}
    >
      <>{children}</>
    </GridItem>
  );
};
